import { render, staticRenderFns } from "./EditDialog.vue?vue&type=template&id=1a5cb784&scoped=true&"
import script from "./EditDialog.vue?vue&type=script&lang=js&"
export * from "./EditDialog.vue?vue&type=script&lang=js&"
import style0 from "./EditDialog.vue?vue&type=style&index=0&id=1a5cb784&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5cb784",
  null
  
)

export default component.exports
import {QInput,QEditor,QCheckbox,QRadio,QTree,QUploader} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QInput,QEditor,QCheckbox,QRadio,QTree,QUploader})
